module.exports = __webpack_public_path__ + "entry-150bfe9b/siemens-photo-b092c52b163c23f920e345d03fa81a03.webp";